// REDESIGN 2024

import { configureFullNav } from './configureFullNav';
import { breakingNewsElement } from './navigationElements';
import Sentry from '@sentry/browser';

export const navigation = (navigation: HTMLElement) => {
  const navigationToggle = navigation.querySelector('[data-navigation-open]');
  const fullNav: HTMLElement | null = document.querySelector('.blesk-full-nav');
  const html: HTMLElement | null = document.documentElement;

  if (!navigationToggle || !fullNav) {
    Sentry.captureException('navigation: Chybí některý z elementů navigace');
    return;
  }

  // Přidat na body třídu 'body--navigation'
  document.body.classList.add('body--navigation');

  // Otevřít 'megamenu' (černá plachta přes celou obrazovku)
  navigationToggle.addEventListener('click', () => {
    fullNav.classList.add('blesk-full-nav--show');
    html.style.overflow = 'hidden';
  });

  handleWrapperSpacings(navigation);

  configureFullNav();
};

// Vizuálně ošetřit nesourodost obalových elementů na úrovni design-base (pro desktop)
// TODO: do budoucna po redesign design-base šablon by mělo jít smazat
export const handleWrapperSpacings = (navigation: HTMLElement | null) => {
  const wrapper = navigation?.parentElement;
  const navigationHeight = navigation?.clientHeight;

  // Přidat padding-top na wrapper, aby se obsah nepřekrýval s navigací
  if (wrapper && navigationHeight && !breakingNewsElement) {
    wrapper.style.paddingTop = `${navigationHeight}px`;
  }
};
